import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Link as RouterLink } from 'react-router-dom';
import IconMessage, { IconMessageIcon } from './IconMessage';

interface EmptyResultProps {
  title: string;
  subtitle: string;
  sx?: React.CSSProperties;
  button?: {
    text: string;
    to?: string;
    props?: object;
    onClick?: () => void;
  };
}

const EmptyResult = ({
  title,
  subtitle,
  sx = {},
  button,
}: EmptyResultProps) => {
  const { t } = useTranslation();
  return (  
  

    <Box
      sx={{
        height: 'calc(100vh - 512px)',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderBottom: 'none',
        ...sx,
      }}
    >
      <IconMessage
        icon={IconMessageIcon.SEARCH_WARNING}
        title={title}
        subtitle={subtitle}
        buttonText={button?.text}
        onClickButton={button?.onClick}
        buttonProps={
          button
            ? {
                to: button.to,
                component: RouterLink,
                ...button.props,
              }
            : undefined
        }
      />
    </Box>
  );
};

export default EmptyResult;
